import React from "react";
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom"

import FailedIcon from "../../../../images/kredivo-payment-declined.png";

const FailedResult = ({
  invoice_number,
  header_text,
  children,
  history
}) => {
  return (
    <div className="failed-payment-wrapper">
      <div className="image-wrapper">
        <KickImage src={FailedIcon} alt="Failed." />
      </div>
      <div className="header-wrapper">
        <p>{header_text}</p>
      </div>
      {children}
      <div className="invoice-failed-button-wrapper">
        <div className="button"
          onClick={() => history.replace("/")}
        >
          <p>Back to Homepage</p>
        </div>
      </div>
    </div>
  )
}

export default withRouter(FailedResult)